import { render, staticRenderFns } from "./cardDetails copy.vue?vue&type=template&id=4ee8109d&"
import script from "./cardDetails copy.vue?vue&type=script&lang=js&"
export * from "./cardDetails copy.vue?vue&type=script&lang=js&"
import style0 from "./cardDetails copy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports